export default "__VITE_ASSET__Qp_unuZU__"